import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunks for async actions
export const fetchAppFriendlyNames = createAsyncThunk(
    'mappings/fetchAppFriendlyNames',
    async () => {
        const response = await axios.get('/users/friendly-names');
        return response.data.data;
    }
);

export const fetchAggregatorApps = createAsyncThunk(
    'mappings/fetchAggregatorApps',
    async () => {
        const response = await axios.get('/users/aggregator-apps');
        return response.data.data;
    }
);

const initialState = {
    friendlyNames: {},
    aggregatorApps: [],
    status: 'idle',
    error: null,
};

const mappingsSlice = createSlice({
    name: 'mappings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppFriendlyNames.fulfilled, (state, action) => {
                state.friendlyNames = action.payload;
            })
            .addCase(fetchAggregatorApps.fulfilled, (state, action) => {
                state.aggregatorApps = action.payload;
            });
    },
});

export default mappingsSlice.reducer; 